import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-base text-white"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-950">琪琪影院</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              汇聚电视剧全集、最新电视剧、热门电视剧，韩剧国产剧全覆盖，高清在线追剧首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/korean" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">韩剧</Link></li>
              <li><Link to="/category/chinese" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">国产剧</Link></li>
              <li><Link to="/category/american" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">美剧</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">热门推荐</h4>
            <ul className="space-y-2.5">
              <li><Link to="/article/show-2" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">狂飙</Link></li>
              <li><Link to="/article/show-1" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">眼泪女王</Link></li>
              <li><Link to="/article/show-6" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">繁花</Link></li>
              <li><Link to="/article/show-3" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">黑暗荣耀</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/category/japanese" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">日剧</Link></li>
            </ul>
            <div className="flex items-center space-x-3 mt-5">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="邮箱" rel="nofollow">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 琪琪影院 qiyicinema.com 版权所有
          </p>
          <div className="flex items-center space-x-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}